import { render, staticRenderFns } from "./station-detail.vue?vue&type=template&id=509e93bd&scoped=true&"
import script from "./station-detail.vue?vue&type=script&lang=js&"
export * from "./station-detail.vue?vue&type=script&lang=js&"
import style0 from "./station-detail.vue?vue&type=style&index=0&id=509e93bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e93bd",
  null
  
)

export default component.exports